export enum TipoProtocolloEnum {
/*   ARRIVO_CARTACEO = <any>"ARRIVO_CARTACEO",
  ARRIVO_DIGITALE = <any>"ARRIVO_DIGITALE", */
  PARTENZA_DIGITALE = <any>"PARTENZA_DIGITALE",
  PARTENZA_CARTACEO = <any>"PARTENZA_CARTACEO",
  INTERNO_CARTACEO = <any>"INTERNO_CARTACEO",
  INTERNO_DIGITALE = <any>"INTERNO_DIGITALE"
}
